import {useInfiniteQuery} from "@tanstack/react-query";

import {eatClubClient} from "@globals/config/apiClient";

import {DishReviewsResponse, UseDishResponse} from "./interfaces";

function getDishReviews(
  dishID: number,
  nextURL?: string
): Promise<DishReviewsResponse> {
  if (!nextURL) {
    // first time we construct this URL manually
    nextURL = `/api/v3/reviews/${dishID}/`;
  }
  // other times we recieving next page url(nextURL) in the response form BE
  return eatClubClient.get(nextURL).then((response) => response.data);
}

// dishID is really a menu item id
export default function useDishReviews(dishID: number): UseDishResponse {
  const {data, isPending, fetchNextPage, hasNextPage, isFetchingNextPage} =
    useInfiniteQuery({
      queryKey: ["dishReviews", dishID],
      queryFn: ({pageParam}) => getDishReviews(dishID, pageParam),
      initialPageParam: undefined,
      getNextPageParam: (lastPage) => lastPage.next,
    });

  return {
    data: data?.pages,
    fetchNextPage,
    hasNextPage,
    isLoading: isPending || isFetchingNextPage,
  };
}
